import { genThemedStyled } from '../../utilities/theme';
import { FUTURO_TYPEFACES as F } from '../../foundations/font';
import S from '../../foundations/size';
import { ColorCodes } from '../../foundations/color';

type themeStyles = {
  backgroundColor: ColorCodes;
  anchorColor: ColorCodes;
  dividerColor: ColorCodes;
  activeColor: ColorCodes;
  accountBackgroundColor: ColorCodes;
  accountCircleColor: ColorCodes;
  textColor: ColorCodes;
  textHoverColor: ColorCodes;
  textHoverBGColor: ColorCodes;
  nameColor: ColorCodes;
  emailColor: ColorCodes;
  circleInitialsColor: ColorCodes;
  subTextColor: ColorCodes;
  actionTextColor: ColorCodes;
};

const ThemeStyled = genThemedStyled<themeStyles>();

export const IconWrapper = ThemeStyled.div({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const ContentWrapper = ThemeStyled.div({
  padding: `0 0 ${S.XXS} 0`,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const AccountDropdownWrapper = ThemeStyled.div<{
  isActive: boolean;
  theme: themeStyles;
}>(({ isActive, theme }) => ({
  position: 'relative',
  width: S.XXL,
  height: S.XXL,
  display: 'flex',
  justifyContent: 'center',
  borderRadius: '50%',
  alignItems: 'center',
  backgroundColor: isActive ? theme.activeColor : 'unset',
  ':hover': {
    backgroundColor: theme.activeColor,
    cursor: 'pointer',
  },
  ':active': {
    backgroundColor: theme.activeColor,
    cursor: 'pointer',
  },
}));

export const AccountSummaryWrapper = ThemeStyled.div(p => ({
  backgroundColor: p.theme.accountBackgroundColor,
  borderRadius: S.XXXS,
}));

export const AccountSummaryBlock = ThemeStyled.div({
  display: 'flex',
  flexDirection: 'row',
  padding: `${S.S} ${S.M} ${S.S} ${S.M}`,
  gap: S.XS,
});

export const UserDetailsBlock = ThemeStyled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: S.XXXS,
  flexGrow: 1,
});

export const NameWrapper = ThemeStyled.h5(
  p => ({
    color: p.theme.nameColor,
    marginBlock: 0,
    cursor: 'default !important',
  }),
  F.H5
);

export const EmailWrapper = ThemeStyled.label(
  p => ({
    color: p.theme.emailColor,
    cursor: 'default !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '11rem',
    overflowWrap: 'anywhere',
  }),
  F.LABEL_SMALL
);

export const TextWrapper = ThemeStyled.button(
  p => ({
    all: 'unset',
    color: p.theme.textColor,
    marginLeft: S.S,
    marginRight: S.S,
    padding: S.XXS,
    cursor: 'pointer',
    ':hover': {
      color: p.theme.textHoverColor,
      backgroundColor: p.theme.textHoverBGColor,
      borderRadius: S.XXXS,
    },
    ':active': {
      color: p.theme.textHoverColor,
      backgroundColor: p.theme.textHoverBGColor,
      borderRadius: S.XXXS,
    },
  }),
  F.LABEL_SMALL_BOLD
);

export const ActionWrapper = ThemeStyled.label(
  p => ({
    color: p.theme.actionTextColor,
    cursor: 'default !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '11rem',
  }),
  F.LABEL_SMALL_BOLD
);

export const LabelContainer = ThemeStyled.div({});

export const SubtextWrapper = ThemeStyled.label(
  p => ({
    color: p.theme.subTextColor,
    cursor: 'default !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '11rem',
  }),
  F.LABEL_SMALL
);

export const CircleIconWrapper = ThemeStyled.div``;
